import * as angular from "angular";
import {IController} from "angular";

export class serviceProgressBarCtrl implements IController {

  progress: any;
  serviceType: any;

  private activeTooltip: boolean;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.activeTooltip = false;
  }

  showProgressPercentage() {
    if (this.progress.numberOfSteps > 0) {
      return Math.round((this.progress.stepNumber / this.progress.numberOfSteps) * 100);
    } else {
      return 0;
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceProgressBar', {
    bindings: {
      progress: '<',
      serviceType: '<?'
    },
    template: require('./service-progress-bar.html').default,
    controller: serviceProgressBarCtrl
  });
